export default __webpack_public_path__ + "static/media/pageFlip.35bca9c7.mp3";